type PaymentNotice = { title?: string | null; body?: string | null; type?: string | null };

export function presentPaymentNotice(notice: PaymentNotice, currency?: string | null): { title: string; body: string; resolved: boolean } {
  const title = notice.title || 'Notification', body = notice.body || '';
  // These saved notices predate structured payment details. Only recognize known payment templates.
  const resolved = title === 'Payment received - earlier attempt failure resolved';
  if (resolved) return { title: 'Payment received - issue resolved', resolved: true,
    body: 'This payment was received after an earlier unsuccessful attempt. No further payment is needed for this receipt. You can view the receipt in Payments.' };
  const failure = /^Payment (?:attempt )?failed$/i.test(title)
    || (notice.type === 'AUTO_PAY_FAILED' && title !== 'Payment not completed');
  if (!failure) return { title, body, resolved: false };

  const amountMatch = /^(?:Your payment of|Payment attempt [A-Z0-9-]+ for)\s+(?:([A-Z]{3})\s+)?(\d+(?:,\d{3})*(?:\.\d+)?)\s+could not be completed\./i.exec(body);
  let amount = '';
  const code = (amountMatch?.[1] || currency || '').trim().toUpperCase();
  if (amountMatch && /^[A-Z]{3}$/.test(code)) {
    const value = Number(amountMatch[2].replace(/,/g, ''));
    if (Number.isFinite(value) && value >= 0) {
      try { amount = new Intl.NumberFormat('en-US', { style: 'currency', currency: code }).format(value); } catch { /* Omit amounts with invalid currencies. */ }
    }
  }
  const reference = /^Payment attempt ([A-Z0-9-]+)\b/i.exec(body)?.[1];
  return { title: 'Payment not completed', resolved: false,
    body: `Your payment${amount ? ` of ${amount}` : ''} could not be completed. Check its status in Payments before trying again. If you already have a successful receipt for this payment, do not pay again.${reference ? ` Reference: ${reference}.` : ''}` };
}
